import styled from '@emotion/styled';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { OfferWorkerStatus } from '../../../graphql/generated/graphql_offer';
import { SPACING_UNIT } from '../../constant/spacing';

type Props = TypographyProps & {
  workerStatus: OfferWorkerStatus;
  className?: string;
};

const backgroundColors: Record<OfferWorkerStatus, string> = {
  PRISTINE: 'transparent',
  APPLIED: '#5CBA47',
  ASSIGNED: '#1DA772',
  REJECTED: '#8F9299',
  CANCELED: '#8F9299',
};

const OfferWorkerStatusLabel = ({ workerStatus, className }: ClassAttributes<HTMLElement> & Props) => {
  let status;
  switch (workerStatus) {
    case 'PRISTINE':
      status = null;
      break;
    case 'APPLIED':
      status = <FormattedMessage id="offer_worker_status.applied" />;
      break;
    case 'ASSIGNED':
      status = <FormattedMessage id="offer_worker_status.assigned" />;
      break;
    case 'REJECTED':
      status = <FormattedMessage id="offer_worker_status.rejected" />;
      break;
    case 'CANCELED':
      status = <FormattedMessage id="offer_worker_status.canceled" />;
      break;
  }

  const ColoredRoot = styled(Root)({
    backgroundColor: backgroundColors[workerStatus],
    color: '#FFF',
  });

  return status ? <ColoredRoot className={className}>{status}</ColoredRoot> : null;
};

const Root = styled(Typography)({
  display: 'inline-block',
  padding: `${SPACING_UNIT / 2}px ${SPACING_UNIT * 2}px`,
  fontWeight: 500,
  textAlign: 'center',
});

export default OfferWorkerStatusLabel;
